import React, { useCallback, useState } from 'react'
import { Alert, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { isSamsungInternet } from '../services/browser'

// #204: Samsung Internet, the default browser on Galaxy devices, tells the user
// the app is on a wrong version. That is Samsung's PWA version handling, not
// something we control, so the only useful response is to send them to Chrome.
//
// App-level on purpose: the problem has nothing to do with any single screen or
// feature. An earlier attempt put this guidance inside the push-notification
// card, so it only appeared on the notifications screen and only when push
// happened to be off — a Samsung user whose notifications worked never saw it.
//
// Rendered by Header, inside the fixed AppBar and below the toolbar (#204
// follow-up): anywhere else in the flow the bar covers it.
const DISMISSED_KEY = 'samsungBrowserNoticeDismissed'

function wasDismissed() {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === '1'
  } catch {
    return false
  }
}

export default function SamsungBrowserNotice() {
  const [dismissed, setDismissed] = useState(wasDismissed)

  const handleDismiss = useCallback(() => {
    setDismissed(true)
    try {
      // Per SESSION, not forever: the version problem does not go away, so the
      // notice comes back next visit rather than being silenced for good.
      sessionStorage.setItem(DISMISSED_KEY, '1')
    } catch {
      /* private mode / storage unavailable — dismissal just won't persist */
    }
  }, [])

  if (dismissed || !isSamsungInternet()) {
    return null
  }

  return (
    <Box sx={{ px: 1, pb: 1 }}>
      <Alert
        data-testid="samsung-browser-notice"
        severity="warning"
        sx={{ textAlign: 'right', direction: 'rtl', py: 0.25 }}
        action={(
          <IconButton
            data-testid="samsung-browser-notice-dismiss"
            size="small"
            color="inherit"
            aria-label="סגירה"
            onClick={handleDismiss}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      >
        בדפדפן של סמסונג המערכת עלולה להיטען בגרסה שאינה מעודכנת.
        מומלץ לפתוח את המערכת בדפדפן Chrome.
      </Alert>
    </Box>
  )
}
